import base from "./base";
import menu from "./menu";
export default {
  ...base,
  ...menu
};



// WEBPACK FOOTER //
// ./src/lang/en/index.js